import moment from 'moment';
export function formatDate(date, format) {
  if (format === void 0) {
    format = 'YYYY-MM-DD';
  }
  if (!date) {
    return '-';
  }
  return moment(date).format(format);
}
export function diffDate(date, lang) {
  var currentDate = new Date();
  var diffYears = moment(currentDate).diff(date, 'year');
  var diffMonths = moment(currentDate).diff(date, 'month');
  var diffDays = moment(currentDate).diff(date, 'day');
  var diffHours = moment(currentDate).diff(date, 'hours');
  var diffMinutes = moment(currentDate).diff(date, 'minutes');
  var diffSeconds = moment(currentDate).diff(date, 'seconds');
  if (diffYears > 0) {
    return lang === 'en-US' ? "Edited " + diffYears + " year ago" : diffYears + '年前编辑过';
  }
  if (diffMonths > 0) {
    return lang === 'en-US' ? "Edited " + diffMonths + " month ago" : diffMonths + '个月前编辑过';
  }
  if (diffDays > 0) {
    return lang === 'en-US' ? "Edited " + diffDays + " day ago" : diffDays + '天前编辑过';
  }
  if (diffHours > 0) {
    return lang === 'en-US' ? "Edited " + diffHours + " hour ago" : diffHours + '小时前编辑过';
  }
  if (diffMinutes > 0) {
    return lang === 'en-US' ? "Edited " + diffMinutes + " minute ago" : diffMinutes + '分钟前编辑过';
  }
  if (diffSeconds > 0) {
    return lang === 'en-US' ? "Edited " + diffSeconds + " second ago" : diffSeconds + '秒钟前编辑过';
  }
  return '正在编辑';
}
export var formatImgUrl = function formatImgUrl(url) {
  if (url) {
    if (url.indexOf('byteimg.com') > -1) {
      return url;
    }
    return "//p1-arco.byteimg.com" + url;
  }
  return url;
};